const PROPORTION_100 = 100;
const PROPORTION_75 = 75;
const PROPORTION_50 = 50;
const PROPORTION_25 = 25;
const PROPORTION_10 = 10;

export const calculateProportionalValueOriginal = length => {
  let proportionalValue;
  if (length < 10) {
    proportionalValue = PROPORTION_100;
  } else if (length >= 10 && length <= 20) {
    proportionalValue = PROPORTION_75;
  } else if (length > 20 && length <= 40) {
    proportionalValue = PROPORTION_50;
  } else {
    proportionalValue = PROPORTION_25;
  }

  return Math.round(length * (proportionalValue / 100));
};

export const calculateProportionalValueVariant = length => {
  let proportionalValue;
  if (length < 6) {
    return 1;
  } else if (length >= 6 && length <= 39) {
    proportionalValue = PROPORTION_25;
  } else {
    proportionalValue = PROPORTION_10;
  }

  return Math.round(length * (proportionalValue / 100));
};

export const calculateProportionalValue = (
  length,
  useAlternativeProportions
) => {
  if (useAlternativeProportions) {
    return calculateProportionalValueVariant(length);
  }
  return calculateProportionalValueOriginal(length);
};

export const mergeSoldOutMarkers = (
  markers,
  soldOutMarkers,
  useAlternativeProportions = false
) => {
  const nMarkers = markers.length;
  const maxSoMarkers = calculateProportionalValue(
    nMarkers,
    useAlternativeProportions
  );
  const cappedSoMarkers = soldOutMarkers.slice(0, maxSoMarkers);

  return markers.reduce((acc, marker, i) => {
    const withMarker = [...acc, marker];
    const soToInsert = i % 2 ? null : cappedSoMarkers[Math.floor(i / 2)];

    return soToInsert ? [...withMarker, soToInsert] : withMarker;
  }, []);
};

export const splitMarkers = (markerList = []) => {
  const soMarkers = [];
  const markers = [];

  markerList.forEach(marker => {
    if (marker.so) {
      soMarkers.push(marker);
    } else {
      markers.push(marker);
    }
  });

  return { soMarkers, markers };
};
